module.exports = __webpack_public_path__ + "img/20220219_072402.2b41b951.jpg";